import React, { useState } from 'react';
import './App.css';

// ============================================================
// MOCK DATA — mirrors reference site (clore-lead-tracker.pages.dev)
// ============================================================

const USERS = [
  { email: 'admin@clore.local', password: 'admin123', role: 'admin', name: 'Admin Team', label: 'super admin' },
  { email: 'clinic@clore.local', password: 'clinic123', role: 'clinic', name: 'Clinic Desk', label: 'clinic' },
  { email: 'aina@example.com', password: 'affiliate123', role: 'affiliate', name: 'Aina Partners', label: 'affiliate', affiliateId: 'AF-KL7X2Q' },
];

const STAFF_ACCOUNTS = [
  { name: 'Admin Team', email: 'admin@clore.local', type: 'admin', affiliateAccess: 'All affiliates' },
  { name: 'Clinic Desk', email: 'clinic@clore.local', type: 'clinic', affiliateAccess: 'All affiliates' },
  { name: 'Doctor Lia', email: 'lia@clore.local', type: 'clinic', affiliateAccess: 'All affiliates' },
];

const AFFILIATES = [
  { name: 'Aina Partners', id: 'AF-KL7X2Q', email: 'aina@example.com' },
  { name: 'Rafiq Wellness', id: 'AF-RF82MA', email: 'rafiq@example.com' },
  { name: 'Mira Beauty Studio', id: 'AF-MR44BT', email: 'mira@example.com' },
];

const INITIAL_LEADS = [
  { id: 1, name: 'Farah N.', phone: '+60 12-555 0198', email: 'farah@example.com', service: 'Skin consultation', affiliateId: 'AF-KL7X2Q', status: 'new', payment: 'pending', saleAmount: 1200, commission: 0 },
  { id: 2, name: 'Daniel Lim', phone: '+60 16-220 7741', email: 'daniel.lim@example.com', service: 'Hair restoration consultation', affiliateId: 'AF-KL7X2Q', status: 'won', payment: 'bought', saleAmount: 1800, commission: 180 },
  { id: 3, name: 'Nur Aisyah', phone: '+60 19-604 2217', email: 'aisyah@example.com', service: 'Acne treatment', affiliateId: 'AF-KL7X2Q', status: 'appointment_scheduled', payment: 'pending', saleAmount: 1200, commission: 0 },
  { id: 4, name: 'Jason Tan', phone: '+60 11-333 9075', email: 'jason.tan@example.com', service: 'Dental whitening', affiliateId: 'AF-RF82MA', status: 'contacted', payment: 'pending', saleAmount: 1200, commission: 0 },
  { id: 5, name: 'Sofia Rahman', phone: '+60 13-445 9012', email: 'sofia@example.com', service: 'Physiotherapy package', affiliateId: 'AF-RF82MA', status: 'won', payment: 'bought', saleAmount: 950, commission: 120 },
  { id: 6, name: 'Mei Wen', phone: '+60 17-892 1106', email: 'mei.wen@example.com', service: 'General health screening', affiliateId: 'AF-RF82MA', status: 'lost', payment: 'not_bought', saleAmount: 1200, commission: 0 },
  { id: 7, name: 'Priya K.', phone: '+60 18-770 4304', email: 'priya@example.com', service: 'Laser facial', affiliateId: 'AF-MR44BT', status: 'consulted', payment: 'pending', saleAmount: 1200, commission: 0 },
  { id: 8, name: 'Hafiz Omar', phone: '+60 14-622 8108', email: 'hafiz@example.com', service: 'Weight management consult', affiliateId: 'AF-MR44BT', status: 'won', payment: 'bought', saleAmount: 2400, commission: 300 },
];

const STATUS_OPTIONS = ['new', 'contacted', 'appointment_scheduled', 'consulted', 'won', 'lost'];
const PAYMENT_OPTIONS = ['pending', 'bought', 'not_bought'];

// ============================================================
// UTILITY COMPONENTS
const TAG_COLORS = {
  new: 'bg-[#e0e7ff] text-[#3730a3]', // Light Indigo
  contacted: 'bg-[#f1f5f9] text-[#475569]', // Light Slate
  appointment_scheduled: 'bg-[#f3e8ff] text-[#6b21a8]', // Light Purple
  consulted: 'bg-[#cffafe] text-[#164e63]', // Light Cyan
  won: 'bg-[#dcfce7] text-[#166534]', // Green
  lost: 'bg-[#fee2e2] text-[#991b1b]', // Light Red
  pending: 'bg-[#fef3c7] text-[#92400e]', // Light amber
  bought: 'bg-[#fbbf24] text-[#452000]', // Match image: Solid gold, dark text
  not_bought: 'bg-[#f1f5f9] text-[#64748b]', // Light slate
  default: 'bg-[#f8fafc] text-[#64748b]'
};

const StatusBadge = ({ status }) => (
  <span className={`px-2.5 py-1 rounded-md text-[10px] font-black uppercase tracking-widest inline-block ${TAG_COLORS[status] || TAG_COLORS.default}`}>
    {status.replace(/_/g, ' ')}
  </span>
);

const KpiCard = ({ icon, label, value, accent }) => (
  <div className={`${accent ? 'bg-primary text-on-primary border-primary/20' : 'bg-white text-on-surface border-black/5'} p-6 rounded-[28px] shadow-[0_4px_30px_rgba(0,0,0,0.03)] border flex flex-col gap-3 transition-transform hover:scale-[1.02]`}>
    <div className={`w-10 h-10 rounded-xl ${accent ? 'bg-white/15' : 'bg-primary/5 border border-primary/10'} flex items-center justify-center`}>
      <span className={`material-symbols-outlined ${accent ? 'text-white' : 'text-primary opacity-80'}`}>{icon}</span>
    </div>
    <div>
      <p className={`text-[11px] font-bold uppercase tracking-widest ${accent ? 'text-white/70' : 'text-on-surface-variant/60'}`}>{label}</p>
      <p className="text-[32px] font-bold tracking-tight mt-1 leading-none">{value}</p>
    </div>
  </div>
);

const TopAppBar = ({ user, onLogout }) => (
  <header className="fixed top-0 w-full z-50 bg-[#f7f5ff]/80 backdrop-blur-xl shadow-[0_12px_32px_-4px_rgba(36,44,81,0.08)]">
    <div className="flex justify-between items-center px-6 py-4 max-w-7xl mx-auto w-full">
      <div className="flex items-center gap-4">
        <div className="w-10 h-10 rounded-xl bg-primary flex items-center justify-center shadow-lg shadow-primary/20 shrink-0">
          <span className="material-symbols-outlined text-white text-xl">insights</span>
        </div>
        <div>
          <h1 className="text-xl font-black text-primary tracking-tight hidden sm:block">Clore Lead Tracker</h1>
        </div>
      </div>
      <div className="flex items-center gap-4">
        <div className="hidden md:flex items-center gap-3 bg-surface-container-lowest px-4 py-2 rounded-full shadow-sm">
          <div className="w-7 h-7 rounded-full bg-primary/10 flex items-center justify-center">
            <span className="material-symbols-outlined text-primary text-sm">person</span>
          </div>
          <div>
            <p className="text-xs font-bold text-on-surface leading-none">{user.name}</p>
            <p className="text-[10px] font-bold text-primary uppercase tracking-widest">{user.label}</p>
          </div>
        </div>
        <button onClick={onLogout} className="px-3 py-2 sm:px-4 sm:py-2 text-on-surface-variant hover:text-error text-[13px] sm:text-sm font-bold rounded-lg hover:bg-error/5 transition-all flex items-center gap-1.5 shrink-0">
          <span className="material-symbols-outlined text-[18px] sm:text-sm">logout</span>
          <span className="hidden sm:inline-block">Log out</span>
        </button>
      </div>
    </div>
  </header>
);

// ============================================================
// LOGIN SCREEN
// ============================================================

const LoginScreen = ({ onLogin }) => {
  const [email, setEmail] = useState('admin@clore.local');
  const [password, setPassword] = useState('admin123');
  const [error, setError] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    const user = USERS.find(u => u.email === email && u.password === password);
    if (user) { onLogin(user); setError(''); }
    else { setError('Invalid credentials. Try a demo account below.'); }
  };

  return (
    <div className="text-on-surface min-h-screen flex flex-col items-center justify-center selection:bg-primary-container selection:text-on-primary-container relative overflow-hidden bg-cover bg-center bg-no-repeat" style={{ backgroundImage: 'url(/login-bg.png)' }}>
      <div className="absolute inset-0 bg-white/40 pointer-events-none"></div>

      <main className="w-full max-w-[1000px] z-10 px-6 login-card-entrance relative">
        <div className="rounded-[2rem] shadow-[0_24px_80px_-12px_rgba(0,0,0,0.15)] flex flex-col lg:flex-row overflow-hidden bg-white/90 backdrop-blur-md border border-white/20 min-h-[550px]">
          {/* Left: Hero panel */}
          <div className="lg:w-1/2 bg-primary p-10 lg:p-14 text-on-primary relative flex flex-col justify-center overflow-hidden">
            <div className="absolute top-0 right-0 w-48 h-48 bg-white/5 rounded-full -mr-16 -mt-16 blur-xl pointer-events-none"></div>
            <div className="absolute bottom-0 left-0 w-32 h-32 bg-secondary-container/10 rounded-full -ml-10 -mb-10 blur-lg pointer-events-none"></div>
            <div className="relative z-10 space-y-5">
              <div className="flex items-center gap-3 group">
                <div className="w-10 h-10 bg-white/10 rounded-xl flex items-center justify-center backdrop-blur-sm border border-white/10 relative overflow-hidden logo-shimmer">
                  <span className="material-symbols-outlined text-white text-xl">insights</span>
                </div>
                <span className="text-[17px] font-black tracking-tight opacity-90">Clore Lead Tracker</span>
              </div>
              <h1 className="text-4xl lg:text-[42px] font-extrabold leading-[1.15] tracking-tight">
                Sign in to <span className="text-secondary-fixed">lead tracking</span>
              </h1>
              <p className="text-white/70 leading-relaxed max-w-sm text-sm">
                Internal admin, clinic, and affiliate pages require a demo account.
              </p>
            </div>
            
            <div className="relative z-10 mt-12 bg-black/10 backdrop-blur-md rounded-2xl p-5 border border-white/10">
              <h3 className="text-xs font-black uppercase tracking-widest text-white/50 mb-3">Demo accounts</h3>
              <div className="space-y-2 text-sm">
                {USERS.map(u => (
                  <button key={u.email} onClick={() => { setEmail(u.email); setPassword(u.password); }} className="w-full text-left flex items-center justify-between py-1.5 px-3 -mx-3 rounded-lg hover:bg-white/10 transition-colors group">
                    <div>
                      <span className="text-white font-bold">{u.email}</span>
                      <span className="text-white/40 ml-2 text-xs">{u.password}</span>
                    </div>
                    <span className="text-secondary-fixed text-[10px] font-black uppercase tracking-widest opacity-0 group-hover:opacity-100 transition-opacity">{u.label}</span>
                  </button>
                ))}
              </div>
            </div>
          </div>

          {/* Right: Form */}
          <div className="lg:w-1/2 p-10 lg:p-14 flex flex-col justify-center">
            <h2 className="text-[32px] font-black tracking-tight text-on-surface mb-2">Welcome back.</h2>
            <p className="text-sm font-medium text-on-surface-variant mb-8">Enter your credentials to continue.</p>
            
            <form onSubmit={handleSubmit} className="space-y-5">
              {error && (
                <div className="bg-error/10 text-error px-4 py-3 rounded-xl text-sm font-bold flex items-center gap-2">
                  <span className="material-symbols-outlined text-sm">warning</span>{error}
                </div>
              )}
              <div className="space-y-2">
                <label className="text-xs font-black uppercase tracking-widest text-on-surface-variant/70">Email</label>
                <input value={email} onChange={e => setEmail(e.target.value)} className="w-full bg-surface-container-low border-none rounded-xl py-4 px-4 focus:ring-2 focus:ring-primary/20 focus:bg-primary/5 transition-all outline-none text-on-surface font-bold text-sm" type="email" />
              </div>
              <div className="space-y-2">
                <label className="text-xs font-black uppercase tracking-widest text-on-surface-variant/70">Password</label>
                <input value={password} onChange={e => setPassword(e.target.value)} className="w-full bg-surface-container-low border-none rounded-xl py-4 px-4 focus:ring-2 focus:ring-primary/20 focus:bg-primary/5 transition-all outline-none text-on-surface font-bold text-sm" type="password" />
              </div>
              <button type="submit" className="w-full mt-2 bg-primary text-white font-bold py-4 rounded-xl shadow-lg shadow-primary/30 hover:shadow-xl hover:shadow-primary/40 hover:-translate-y-0.5 transition-all flex items-center justify-center gap-2 group active:scale-[0.98]">
                <span>Sign in</span>
                <span className="material-symbols-outlined text-sm transition-transform group-hover:translate-x-1">arrow_forward</span>
              </button>
            </form>
          </div>
        </div>
      </main>

      {/* Background effects */}
      <div className="fixed top-0 left-0 w-full h-full -z-10 pointer-events-none overflow-hidden">
        <div className="absolute -top-[10%] -left-[5%] w-[40%] h-[40%] bg-primary/5 blur-[120px] rounded-full"></div>
        <div className="absolute top-[60%] -right-[5%] w-[30%] h-[50%] bg-secondary-container/5 blur-[120px] rounded-full"></div>
      </div>
    </div>
  );
};

// ============================================================
// LEAD WORK QUEUE
// ============================================================

const LeadWorkQueue = ({ leads, setLeads, readOnly }) => {
  const [sortConfig, setSortConfig] = useState(null);

  const requestSort = (key) => {
    let direction = 'asc';
    if (sortConfig && sortConfig.key === key && sortConfig.direction === 'asc') {
      direction = 'desc';
    }
    setSortConfig({ key, direction });
  };

  const sortedLeads = React.useMemo(() => {
    if (!sortConfig) return leads;
    return [...leads].sort((a, b) => {
      let aVal = a[sortConfig.key];
      let bVal = b[sortConfig.key];
      
      if (sortConfig.key === 'payment') {
        aVal = aVal === 'bought' ? a.saleAmount : -1;
        bVal = bVal === 'bought' ? b.saleAmount : -1;
      }

      if (aVal < bVal) return sortConfig.direction === 'asc' ? -1 : 1;
      if (aVal > bVal) return sortConfig.direction === 'asc' ? 1 : -1;
      return 0;
    });
  }, [leads, sortConfig]);

  const SortIcon = ({ column }) => {
    if (!sortConfig || sortConfig.key !== column) return <span className="material-symbols-outlined text-[14px] opacity-0 group-hover:opacity-40 transition-opacity ml-1 pointer-events-none">sort</span>;
    return <span className="material-symbols-outlined text-[14px] opacity-100 text-primary ml-1 pointer-events-none">{sortConfig.direction === 'asc' ? 'arrow_upward' : 'arrow_downward'}</span>;
  };

  const updateLead = (id, field, value) => {
    setLeads(prev => prev.map(l => l.id === id ? { ...l, [field]: value } : l));
  };

  return (
    <div className="bg-white rounded-[28px] overflow-hidden shadow-[0_4px_30px_rgba(0,0,0,0.03)] border border-black/5">
      <div className="overflow-x-auto hide-scrollbar pb-2">
        <table className="w-full min-w-[950px] table-fixed text-left text-sm">
          <thead>
            <tr className="bg-primary/10 text-primary border-b border-primary/20 text-xs font-black uppercase tracking-wider">
              <th className="w-[30%] px-6 py-4 pr-2">
                <button onClick={() => requestSort('name')} className="flex items-center hover:opacity-80 transition-opacity group w-full outline-none text-left">
                  Lead Details <SortIcon column="name" />
                </button>
              </th>
              <th className="w-[25%] px-2 py-4">
                <button onClick={() => requestSort('phone')} className="flex items-center hover:opacity-80 transition-opacity group w-full outline-none text-left">
                  Contact <SortIcon column="phone" />
                </button>
              </th>
              <th className="w-[20%] px-2 py-4">
                <button onClick={() => requestSort('status')} className="flex items-center justify-center hover:opacity-80 transition-opacity group w-full outline-none text-center">
                  Status <SortIcon column="status" />
                </button>
              </th>
              <th className="w-[25%] px-6 py-4">
                <button onClick={() => requestSort('payment')} className="flex items-center justify-center hover:opacity-80 transition-opacity group w-full outline-none text-center">
                  Outcome <SortIcon column="payment" />
                </button>
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-black/10">
            {sortedLeads.map(lead => (
              <tr key={lead.id} className="hover:bg-primary/[0.04] even:bg-surface-variant/[0.02] transition-colors group">
                <td className="px-6 py-5 align-middle bg-primary/[0.02] pr-2 border-r border-surface-variant/10">
                  <div className="font-bold text-on-surface text-[15px] tracking-tight truncate">{lead.name}</div>
                  <div className="text-on-surface-variant text-xs font-semibold mt-0.5 truncate pr-4">{lead.service}</div>
                  <div className="mt-2.5 flex items-center flex-wrap gap-2">
                    {!readOnly && (
                      <div className="inline-flex items-center justify-center px-1.5 py-1 rounded-md bg-primary/10 text-primary text-[10px] font-black uppercase tracking-widest border border-primary/20 leading-none">
                        Via {lead.affiliateId}
                      </div>
                    )}
                    <StatusBadge status={lead.status} />
                    <StatusBadge status={lead.payment} />
                  </div>
                </td>
                <td className="px-4 py-5 align-middle">
                  <div className="space-y-1.5 text-on-surface-variant text-xs font-bold">
                    <div className="flex items-center gap-2 truncate whitespace-nowrap"><span className="material-symbols-outlined text-[15px] text-primary shrink-0 opacity-80">call</span>{lead.phone}</div>
                    <div className="flex items-center gap-2 truncate whitespace-nowrap"><span className="material-symbols-outlined text-[15px] text-primary shrink-0 opacity-80">mail</span>{lead.email}</div>
                  </div>
                </td>
                <td className="px-2 py-5 align-middle text-center">
                  <div className="flex flex-col items-center gap-3">
                    {!readOnly ? (
                      <div className="relative w-[130px] mx-auto group">
                        <select value={lead.status} onChange={e => updateLead(lead.id, 'status', e.target.value)}
                          className="appearance-none w-full bg-white border border-surface-variant/20 rounded-lg py-1.5 pl-3 pr-3 text-[11px] font-black focus:ring-2 focus:ring-primary/20 cursor-pointer shadow-sm text-center text-on-surface hover:bg-surface-container-lowest transition-colors uppercase tracking-widest">
                          {STATUS_OPTIONS.map(s => <option key={s} value={s}>{s.replace(/_/g, ' ').toUpperCase()}</option>)}
                        </select>
                      </div>
                    ) : (
                      <span className="text-[11px] font-black text-on-surface-variant uppercase tracking-widest">{lead.status.replace(/_/g, ' ')}</span>
                    )}
                  </div>
                </td>
                <td className="px-4 py-5 align-middle text-center">
                  <div className="flex flex-col items-center gap-3 w-[150px] mx-auto">
                    {!readOnly && (
                      <div className="relative w-full group">
                         <select value={lead.payment} onChange={e => updateLead(lead.id, 'payment', e.target.value)}
                          className="appearance-none w-full bg-white border border-surface-variant/20 rounded-lg py-1.5 pl-3 pr-3 text-[11px] font-black focus:ring-2 focus:ring-primary/20 cursor-pointer shadow-sm text-center text-on-surface hover:bg-surface-container-lowest transition-colors uppercase tracking-widest">
                          {PAYMENT_OPTIONS.map(p => <option key={p} value={p}>{p.replace(/_/g, ' ').toUpperCase()}</option>)}
                        </select>
                      </div>
                    )}
                    
                    {!readOnly ? (
                      <div className="flex items-center justify-between w-full flex-nowrap gap-2">
                        <div className="flex items-center bg-white border border-surface-variant/20 rounded-lg px-2.5 py-1 shadow-sm focus-within:ring-2 focus-within:ring-primary/20 transition-all flex-1 min-w-[75px]">
                          <span className="text-[10px] font-bold text-on-surface-variant/50 mr-1.5">RM</span>
                          <input type="text" inputMode="numeric" value={lead.saleAmount} onChange={e => updateLead(lead.id, 'saleAmount', Number(e.target.value.replace(/\D/g, '')))}
                            className="w-full bg-transparent border-none p-0 text-[11px] font-black text-on-surface focus:ring-0 text-left min-w-0" />
                        </div>
                        
                        <button className="text-white bg-primary hover:bg-primary/90 shadow shadow-primary/20 hover:shadow-md h-[28px] rounded-lg flex items-center justify-center transition-all group shrink-0 px-2.5 gap-1.5" title="Record sale">
                          <span className="material-symbols-outlined text-[14px]">check_circle</span>
                          <span className="text-[9px] font-black uppercase tracking-wider">Record</span>
                        </button>
                      </div>
                    ) : (
                      <div className="flex flex-col items-center gap-1.5">
                        <span className="text-[11px] font-black text-on-surface-variant uppercase tracking-widest block">{lead.payment.replace(/_/g, ' ')}</span>
                        {lead.commission > 0 && (
                          <div className="text-[10px] font-black uppercase tracking-widest text-secondary bg-secondary/10 px-2 py-0.5 rounded border border-secondary/20 block">RM {lead.commission} Comm</div>
                        )}
                      </div>
                    )}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

// ============================================================
// ADMIN DASHBOARD
// ============================================================

const AdminDashboard = ({ leads, setLeads, onCopy }) => {
  const totalLeads = leads.length;
  const wonLeads = leads.filter(l => l.status === 'won').length;
  const totalSales = leads.filter(l => l.payment === 'bought').reduce((s, l) => s + l.saleAmount, 0);
  const totalCommission = leads.reduce((s, l) => s + l.commission, 0);

  return (
    <div className="pt-24 pb-12 px-6 max-w-7xl mx-auto space-y-8">
      {/* KPI Bar */}
      <section className="grid grid-cols-2 md:grid-cols-4 gap-4">
        <KpiCard icon="group" label="Total Leads" value={totalLeads} accent />
        <KpiCard icon="verified" label="Won Leads" value={wonLeads} />
        <KpiCard icon="trending_up" label="Sales" value={`RM ${totalSales.toLocaleString()}`} />
        <KpiCard icon="payments" label="Commission" value={`RM ${totalCommission.toLocaleString()}`} />
      </section>

      <div className="w-full space-y-5">
        <div className="flex items-center justify-between">
          <div>
            <h3 className="text-2xl font-black text-on-surface tracking-tight">Lead work queue</h3>
            <p className="text-sm text-on-surface-variant mt-1">Admin level: update status and record sales.</p>
          </div>
          <span className="bg-primary/10 text-primary border border-primary/20 px-4 py-1.5 rounded-full text-xs font-black tracking-widest uppercase">{totalLeads} leads</span>
        </div>
        <LeadWorkQueue leads={leads} setLeads={setLeads} readOnly={false} />
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 pt-8 border-t border-surface-variant/20 items-stretch">
        <div className="bg-white rounded-[28px] p-8 shadow-[0_4px_30px_rgba(0,0,0,0.03)] border border-black/5 flex flex-col">
          <h3 className="text-xl font-bold tracking-tight text-on-surface mb-1">Staff accounts</h3>
          <p className="text-sm text-on-surface-variant mb-6">Manage clinic access to affiliate leads.</p>
          <div className="space-y-4 flex-1">
            {STAFF_ACCOUNTS.map((s, i) => (
              <div key={i} className="p-5 bg-black/[0.02] rounded-[20px]">
                <div className="flex items-center justify-between mb-2">
                  <div>
                    <p className="font-bold text-on-surface text-[15px]">{s.name}</p>
                    <p className="text-xs text-on-surface-variant font-medium">{s.email}</p>
                  </div>
                  <span className="text-[10px] font-black uppercase tracking-widest text-primary bg-primary/10 px-2.5 py-1 rounded-full">{s.type}</span>
                </div>
                <div className="flex items-center gap-2 mt-4">
                  <span className="text-xs font-bold text-on-surface-variant">Affiliate access</span>
                  <select className="bg-black/[0.03] border-none rounded-xl py-2 px-3 text-xs font-bold text-on-surface focus:ring-2 focus:ring-primary/20 cursor-pointer flex-1">
                    <option>All affiliates</option>
                  </select>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="bg-white rounded-[28px] p-8 shadow-[0_4px_30px_rgba(0,0,0,0.03)] border border-black/5 flex flex-col">
          <h3 className="text-xl font-bold tracking-tight text-on-surface mb-1">Affiliates</h3>
          <p className="text-sm text-on-surface-variant mb-6">Referral codes are generated automatically.</p>
          <div className="space-y-4 flex-1">
            {AFFILIATES.map(a => (
              <div key={a.id} className="p-5 bg-black/[0.02] rounded-[20px] flex flex-col gap-3">
                <div className="flex justify-between items-start">
                  <div>
                    <p className="font-bold text-on-surface text-[15px]">{a.name}</p>
                    <p className="text-primary font-black text-xl tracking-tight mt-0.5">{a.id}</p>
                  </div>
                  <div className="w-10 h-10 rounded-xl bg-primary/10 flex items-center justify-center -mt-1 -mr-1">
                    <span className="material-symbols-outlined text-primary">link</span>
                  </div>
                </div>
                <button onClick={() => onCopy(`https://cookiebytes.my/r/${a.id}`)} className="w-full mt-2 py-2.5 bg-black/[0.03] hover:bg-primary/10 rounded-xl text-sm font-bold text-on-surface-variant hover:text-primary transition-all flex items-center justify-center gap-1.5 focus:ring-2 focus:ring-primary/20">
                  <span className="material-symbols-outlined text-sm">content_copy</span>
                  Copy referral link
                </button>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

// ============================================================
// CLINIC DASHBOARD
// ============================================================

const ClinicDashboard = ({ leads, setLeads }) => {
  const totalLeads = leads.length;
  const wonLeads = leads.filter(l => l.status === 'won').length;
  const totalSales = leads.filter(l => l.payment === 'bought').reduce((s, l) => s + l.saleAmount, 0);
  const totalCommission = leads.reduce((s, l) => s + l.commission, 0);

  return (
    <div className="pt-24 pb-12 px-6 max-w-7xl mx-auto space-y-8">
      <section className="grid grid-cols-2 md:grid-cols-4 gap-4">
        <KpiCard icon="group" label="Total Leads" value={totalLeads} accent />
        <KpiCard icon="verified" label="Won Leads" value={wonLeads} />
        <KpiCard icon="trending_up" label="Sales" value={`RM ${totalSales.toLocaleString()}`} />
        <KpiCard icon="payments" label="Commission" value={`RM ${totalCommission.toLocaleString()}`} />
      </section>

      <div className="w-full space-y-5">
        <div className="flex items-center justify-between">
          <div>
            <h3 className="text-2xl font-black text-on-surface tracking-tight">Lead work queue</h3>
            <p className="text-sm text-on-surface-variant mt-1">Clinic desk: update status and record sales.</p>
          </div>
          <span className="bg-primary/10 text-primary border border-primary/20 px-4 py-1.5 rounded-full text-xs font-black tracking-widest uppercase">{totalLeads} leads</span>
        </div>
        <LeadWorkQueue leads={leads} setLeads={setLeads} readOnly={false} />
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 pt-8 border-t border-surface-variant/20">
        <div className="bg-white rounded-[28px] p-8 shadow-[0_4px_30px_rgba(0,0,0,0.03)] border border-black/5 flex flex-col">
          <h3 className="text-xl font-bold tracking-tight text-on-surface mb-1">Assigned affiliates</h3>
          <p className="text-sm text-on-surface-variant mb-6">This clinic has access to every affiliate partner.</p>
          <div className="space-y-4">
            {AFFILIATES.map(a => (
              <div key={a.id} className="p-5 bg-black/[0.02] rounded-[20px] flex items-center justify-between">
                <div>
                  <p className="font-bold text-on-surface text-[15px] mb-1">{a.name}</p>
                  <p className="text-xs font-medium text-on-surface-variant">{a.email}</p>
                </div>
                <p className="text-[11px] text-primary bg-primary/10 px-2.5 py-1 rounded-md uppercase font-black tracking-widest">{a.id}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

// ============================================================
// AFFILIATE DASHBOARD
// ============================================================

const AffiliateDashboard = ({ leads, user, onCopy, copied }) => {
  const myLeads = leads.filter(l => l.affiliateId === user.affiliateId);
  const totalLeads = myLeads.length;
  const wonLeads = myLeads.filter(l => l.status === 'won').length;
  const totalSales = myLeads.filter(l => l.payment === 'bought').reduce((s, l) => s + l.saleAmount, 0);
  const totalCommission = myLeads.reduce((s, l) => s + l.commission, 0);
  const pendingLeads = myLeads.filter(l => l.payment === 'pending').length;

  const referralUrl = `https://cookiebytes.my/r/${user.affiliateId}`;

  return (
    <div className="pt-24 pb-12 px-6 max-w-7xl mx-auto space-y-8 relative">
      <section className="grid grid-cols-2 md:grid-cols-4 gap-4">
        <KpiCard icon="group" label="Total Leads" value={totalLeads} accent />
        <KpiCard icon="verified" label="Won Leads" value={wonLeads} />
        <KpiCard icon="trending_up" label="Sales" value={`RM ${totalSales.toLocaleString()}`} />
        <KpiCard icon="payments" label="Commission" value={`RM ${totalCommission.toLocaleString()}`} />
      </section>

      <div className="w-full space-y-5">
        <div className="flex items-center justify-between">
          <div>
            <h3 className="text-2xl font-black text-on-surface tracking-tight">Lead work queue</h3>
            <p className="text-sm text-on-surface-variant mt-1">Affiliate view is scoped to own referrals.</p>
          </div>
          <span className="bg-primary/10 text-primary border border-primary/20 px-4 py-1.5 rounded-full text-xs font-black tracking-widest uppercase">{totalLeads} leads</span>
        </div>
        <LeadWorkQueue leads={myLeads} setLeads={() => {}} readOnly={true} />
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 pt-8 border-t border-surface-variant/20 items-stretch">
        <div className="bg-white rounded-[28px] p-8 shadow-[0_4px_30px_rgba(0,0,0,0.03)] border border-black/5 flex flex-col">
          <h3 className="text-xl font-bold tracking-tight text-on-surface mb-1">Referral Link</h3>
          <p className="text-sm text-on-surface-variant mb-6">Share this link to earn commission on leads.</p>
          
          <div className="bg-black/[0.02] p-6 rounded-[20px] flex flex-col items-center justify-center flex-1 mb-6 text-center border border-black/[0.02]">
            <p className="text-sm text-on-surface-variant font-bold uppercase tracking-widest">{user.name}</p>
            <p className="text-4xl font-black text-primary tracking-tight mt-2 mb-3">{user.affiliateId}</p>
            <p className="text-xs font-semibold text-on-surface-variant/70 break-all bg-white px-4 py-2 rounded-lg border border-black/5">{referralUrl}</p>
          </div>
          
          <button onClick={() => onCopy(referralUrl)} className={`w-full py-4 text-white rounded-2xl font-bold text-sm flex items-center justify-center gap-2 transition-all shadow-lg ${copied ? 'bg-emerald-600 shadow-emerald-600/20' : 'bg-primary shadow-primary/20 hover:opacity-90 active:scale-[0.98]'}`}>
            <span className="material-symbols-outlined text-[18px]">
              {copied ? 'check_circle' : 'content_copy'}
            </span>
            {copied ? 'Copied to clipboard!' : 'Copy your link'}
          </button>
        </div>

        <div className="bg-white rounded-[28px] p-8 shadow-[0_4px_30px_rgba(0,0,0,0.03)] border border-black/5 flex flex-col">
          <h3 className="text-xl font-bold tracking-tight text-on-surface mb-1">Affiliate results</h3>
          <p className="text-sm text-on-surface-variant mb-6">Real-time breakdown of your performance.</p>
          <div className="grid grid-cols-3 gap-3 mb-4 flex-1">
            {[
              { label: 'Referrals', value: totalLeads },
              { label: 'Bought', value: wonLeads },
              { label: 'Pending', value: pendingLeads },
            ].map(m => (
              <div key={m.label} className="bg-black/[0.02] rounded-[20px] p-5 text-center flex flex-col justify-center border border-black/[0.02]">
                <p className="text-[10px] font-black uppercase tracking-widest text-on-surface-variant">{m.label}</p>
                <p className="text-2xl font-black text-on-surface mt-1.5">{m.value}</p>
              </div>
            ))}
          </div>
          <div className="bg-primary/5 rounded-[20px] p-6 text-center border border-primary/10">
            <p className="text-xs font-black text-primary/70 uppercase tracking-widest">Total Commission</p>
            <p className="text-4xl font-black text-primary tracking-tighter mt-1">RM {totalCommission.toLocaleString()}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

// ============================================================
// LEAD CAPTURE FORM (public page)
// ============================================================

const LeadCaptureForm = ({ affiliateId, onBack }) => {
  const [submitted, setSubmitted] = useState(false);

  if (submitted) {
    return (
      <div className="min-h-screen bg-surface flex items-center justify-center px-6">
        <div className="bg-surface-container-lowest rounded-[2rem] p-12 shadow-xl text-center max-w-md">
          <div className="w-16 h-16 bg-[#dcfce7] rounded-2xl flex items-center justify-center mx-auto mb-6">
            <span className="material-symbols-outlined text-[#166534] text-3xl">check_circle</span>
          </div>
          <h2 className="text-2xl font-black text-on-surface mb-2">Thank you!</h2>
          <p className="text-on-surface-variant mb-6">Your details have been submitted.</p>
          <button onClick={onBack} className="text-primary font-bold text-sm hover:underline">← Back to sign in</button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-surface flex items-center justify-center px-6 py-12">
      <div className="w-full max-w-[900px] grid grid-cols-1 md:grid-cols-2 gap-0 overflow-hidden rounded-[2rem] shadow-[0_32px_64px_-16px_rgba(36,44,81,0.12)]">
        <div className="bg-primary p-10 text-on-primary flex flex-col justify-between relative overflow-hidden">
          <div className="absolute bottom-0 right-0 w-48 h-48 bg-white/5 rounded-full -mr-16 -mb-16 blur-xl"></div>
          <div className="relative z-10 space-y-6">
            <p className="text-secondary-container font-bold text-xs uppercase tracking-[0.2em]">Referral {affiliateId}</p>
            <h1 className="text-4xl font-extrabold leading-[1.15] tracking-tight">Book your clinic follow-up</h1>
            <p className="text-white/70 leading-relaxed">Leave your details and the clinic team will contact you.</p>
          </div>
          <button onClick={onBack} className="relative z-10 mt-8 text-white/60 text-sm font-bold hover:text-white transition-colors flex items-center gap-1">
            <span className="material-symbols-outlined text-sm">arrow_back</span>Back to sign in
          </button>
        </div>
        <div className="bg-surface-container-lowest p-10 flex flex-col justify-center">
          <form onSubmit={(e) => { e.preventDefault(); setSubmitted(true); }} className="space-y-5">
            {['Customer name', 'Phone', 'Email', 'Interested service'].map(field => (
              <div key={field} className="space-y-2">
                <label className="text-sm font-bold text-on-surface-variant">{field}</label>
                <input className="w-full bg-surface-container-low border-none rounded-xl py-3.5 px-4 focus:ring-2 focus:ring-primary/20 focus:bg-white transition-all text-on-surface font-medium" type={field === 'Email' ? 'email' : 'text'} required />
              </div>
            ))}
            <button type="submit" className="w-full bg-primary text-on-primary font-bold py-4 rounded-xl shadow-lg shadow-primary/30 hover:shadow-xl transition-all flex items-center justify-center gap-2 active:scale-[0.98]">
              <span className="material-symbols-outlined text-sm">send</span>
              Submit lead
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

// ============================================================
// APP SHELL
// ============================================================

export default function App() {
  const [user, setUser] = useState(null);
  const [leads, setLeads] = useState(INITIAL_LEADS);
  const [showCaptureForm, setShowCaptureForm] = useState(false);
  const [copied, setCopied] = useState(false);

  const handleGlobalCopy = (text) => {
    const triggerSuccess = () => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    };

    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText(text).then(triggerSuccess).catch(() => fallback(text));
      return;
    }

    fallback(text);

    function fallback(val) {
      const textArea = document.createElement("textarea");
      textArea.value = val;
      textArea.style.position = "fixed";
      textArea.style.left = "0";
      textArea.style.top = "0";
      textArea.style.opacity = "0";
      textArea.style.fontSize = "16px";
      textArea.setAttribute('readonly', '');
      document.body.appendChild(textArea);
      
      const range = document.createRange();
      range.selectNodeContents(textArea);
      const selection = window.getSelection();
      selection.removeAllRanges();
      selection.addRange(range);
      
      textArea.focus();
      textArea.setSelectionRange(0, 999999);
      
      try {
        if (document.execCommand('copy')) {
          triggerSuccess();
        }
      } catch (err) {
        console.error('Copy failed');
      }
      document.body.removeChild(textArea);
    }
  };

  if (showCaptureForm) {
    return <LeadCaptureForm affiliateId="AF-KL7X2Q" onBack={() => setShowCaptureForm(false)} />;
  }

  if (!user) {
    return <LoginScreen onLogin={(u) => setUser(u)} />;
  }

  return (
    <div className="min-h-screen bg-surface text-on-surface selection:bg-primary-container selection:text-on-primary-container relative">
      <TopAppBar user={user} onLogout={() => setUser(null)} />

      <main className="relative z-10">
        {user.role === 'admin' && <AdminDashboard leads={leads} setLeads={setLeads} onCopy={handleGlobalCopy} />}
        {user.role === 'clinic' && <ClinicDashboard leads={leads} setLeads={setLeads} />}
        {user.role === 'affiliate' && <AffiliateDashboard leads={leads} user={user} onCopy={handleGlobalCopy} copied={copied} />}
      </main>

      <footer className="max-w-7xl mx-auto px-6 pb-8 pt-4">
        <div className="bg-surface-container-low rounded-2xl p-6 flex flex-col md:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-3">
            <span className="material-symbols-outlined text-primary">link</span>
            <div>
              <p className="text-xs font-bold text-on-surface-variant uppercase tracking-wider">Public referral form preview</p>
              <p className="text-sm font-medium text-on-surface-variant">See what customers see when they click a referral link</p>
            </div>
          </div>
          <button onClick={() => setShowCaptureForm(true)} className="bg-surface-container-lowest px-5 py-2.5 rounded-lg font-bold text-sm text-primary hover:bg-primary/5 transition-colors shadow-sm flex items-center gap-2">
            <span className="material-symbols-outlined text-sm">open_in_new</span>
            Preview form
          </button>
        </div>
      </footer>

      {/* Global Modern Overlay Toast */}
      <div className={`fixed bottom-10 left-1/2 -translate-x-1/2 bg-black/90 text-white px-6 py-3 rounded-full text-xs font-bold transition-all z-[9999] flex items-center gap-2 shadow-2xl ${copied ? 'opacity-100 translate-y-0 scale-100' : 'opacity-0 translate-y-8 scale-95 pointer-events-none'}`}>
        <span className="material-symbols-outlined text-emerald-400 text-sm">check_circle</span>
        <span>Referral link copied successfully!</span>
      </div>
    </div>
  );
}
